/**
 * This is intended only for INTLX Team
 * By design, this requires the page to have a script
 * tag of type "application/json" with the id of "js-config".
 *
 * All data contained should be considered static and purely for application
 * hydration.
 */

import freeze from '@mc/fn/freeze';
import { usePageDataStore } from '@mc/globalStore';
import { getMergedReactTranslations } from './internationalization/localeUtils';
import { SUPPORTED_LOCALES } from './internationalization/constants';

const readTranslations = async () => {
  const locale = usePageDataStore?.getState()?.userData?.locale;
  const data = await getMergedReactTranslations(
    locale || SUPPORTED_LOCALES.DEFAULT,
  );
  return freeze(data);
};

export default readTranslations;
